import React from 'react';
import { useTrusteeContext } from '../../../context';
import { isAfter, toDate, isBefore } from 'date-fns';
import { FORM_ERROR } from 'final-form';
import { cardType } from '../../../../common/interfaces';
import { Reason } from '../../../../common/views/remove/reason/reason';
var RemoveReason = function () {
    var _a = useTrusteeContext(), current = _a.current, send = _a.send, i18n = _a.i18n;
    var _b = current.context, remove = _b.remove, trustee = _b.trustee;
    var DateField = [
        {
            type: 'date',
            name: 'date',
            label: i18n.remove.reason.fields.date.label,
            hint: 'For example, 31 3 2019',
            cfg: { mb: 3 },
            required: true,
            validate: function (value) {
                if (!value) {
                    return i18n.remove.reason.errors.pristineDate;
                }
                else if (isBefore(toDate(new Date(value)), toDate(new Date(trustee.effectiveDate)))) {
                    return i18n.remove.reason.errors.dateAddedBeforeEffectiveDate;
                }
                else if (isAfter(toDate(new Date(value)), new Date())) {
                    return i18n.remove.reason.errors.dateAddedInTheFuture;
                }
                else {
                    return undefined;
                }
            },
        },
    ];
    var onSubmit = function (values) {
        var _a;
        if (!values.reason) {
            return _a = {},
                _a[FORM_ERROR] = i18n.remove.reason.errors.pristine,
                _a;
        }
        else {
            send('SELECT', {
                values: {
                    reason: values.reason,
                    date: values.reason === 'not_part_of_scheme' ? undefined : values.date,
                },
            });
        }
    };
    return (React.createElement(Reason, { type: cardType.trustee, i18nRemoveReason: i18n.remove.reason, onSubmit: onSubmit, remove: remove, dateField: DateField }));
};
export default RemoveReason;
//# sourceMappingURL=reason.js.map